/* eslint-env jquery */
/**
 * Rockwell Video Component
 */
import { Component, registerComponent } from 'js/component.js';
import 'vendor/mediaelement/mediaelement-and-player.min.js';
const componentName = 'video';

class Video extends Component {

    /**
     * Initialize Component
     */
    init() {
        // Gated Content
        if (document.videoGateInitialized !== true) {
            window.addEventListener('gcdcGateSubmitted', (event) => {
                const { id } = event.detail;
                $(`.${componentName} div.video-gate[data-gate-id="gate-${id}"]`).hide();
            });
            document.videoGateInitialized = true;
        }

        const initPlayers = () => {
            console.debug('Init Video Players');
            $('video.ra__player').map(function () {
                if ($(this).attr('video-initialized')) return;
                console.debug('Setting video-initialized to be true.');
                $(this).attr('video-initialized', 'true');

                const startLanguage = $(this).attr('data-start-language');
                const videoID = $(this).attr('data-video-id');
                const videoName = $(this).attr('title');
                const videoLanguage = $(this).attr('data-video-language') || '';
                const defaultChaptersLanguage = startLanguage;
                $(this).mediaelementplayer({
                    stretching: 'responsive',
                    alwaysShowControls: true,
                    startLanguage,
                    success: (media, originalNode, instance) => {
                        const setChapterLanguage = (chaptersLanguage) => {
                            if (chaptersLanguage) {
                                const chapter = instance.tracks.find((track) => track.srclang === chaptersLanguage && track.kind === 'chapters');
                                if (chapter) {
                                    instance.drawChapters(chapter);
                                }
                            }
                        };

                        media.addEventListener('loadedmetadata', () => {
                            const digitalData = window.digitalData = window.digitalData || []; // eslint-disable-line no-multi-assign
                            const eventData = {
                                event: 'videoPlayerLoaded',
                                videoDetail: {
                                    videoID,
                                    videoName,
                                    videoLanguage,
                                    videoCaptionLanguage: instance.selectedTrack ? instance.selectedTrack.srclang : '',
                                    videoLength: instance.getDuration()
                                }
                            };
                            digitalData.push(eventData);
                            setChapterLanguage(defaultChaptersLanguage);

                        });

                        media.addEventListener('play', () => {
                            const percentPlayed = Math.floor((instance.getCurrentTime() * 100) / instance.getDuration());
                            if (percentPlayed === 0) return; // Exclude event covered by videoStart

                            const digitalData = window.digitalData = window.digitalData || []; // eslint-disable-line no-multi-assign
                            const eventData = {
                                event: 'videoPlay',
                                videoDetail: {
                                    videoID,
                                    videoName,
                                    videoLanguage,
                                    videoCaptionLanguage: instance.selectedTrack ? instance.selectedTrack.srclang : '',
                                    videoLength: instance.getDuration()
                                }
                            };
                            digitalData.push(eventData);
                        });

                        media.addEventListener('pause', () => {
                            const percentPlayed = Math.floor((instance.getCurrentTime() * 100) / instance.getDuration());
                            if (percentPlayed === 100) return; // Exclude event covered by video100complete

                            const digitalData = window.digitalData = window.digitalData || []; // eslint-disable-line no-multi-assign
                            const eventData = {
                                event: 'videoPause',
                                videoDetail: {
                                    videoID,
                                    videoName,
                                    videoLanguage,
                                    videoCaptionLanguage: instance.selectedTrack ? instance.selectedTrack.srclang : '',
                                    videoLength: instance.getDuration()
                                }
                            };
                            digitalData.push(eventData);
                        });

                        media.addEventListener('captionschange', () => {
                            // Set chapter language upon caption change.
                            const selectedLanguage = instance.selectedTrack?.srclang;
                            setChapterLanguage(selectedLanguage);

                            const digitalData = window.digitalData = window.digitalData || []; // eslint-disable-line no-multi-assign
                            const eventData = {
                                event: 'videoCaptionSelect',
                                videoDetail: {
                                    videoID,
                                    videoName,
                                    videoLanguage,
                                    videoCaptionLanguage: instance.selectedTrack ? instance.selectedTrack.srclang : '',
                                    videoLength: instance.getDuration()
                                }
                            };
                            if (!Number.isNaN(eventData.videoDetail.videoLength)) { // Exclude caption change event on initial load
                                digitalData.push(eventData);
                            }
                        });

                        let markers = [0, 25, 50, 75, 100];

                        media.addEventListener('timeupdate', () => {
                            const percentPlayed = Math.floor((media.getCurrentTime() * 100) / media.getDuration());

                            if (markers.includes(percentPlayed)) {
                                const digitalData = window.digitalData = window.digitalData || []; // eslint-disable-line no-multi-assign
                                let eventType = '';
                                if (percentPlayed === 0) {
                                    eventType = 'videoStart';
                                } else {
                                    eventType = `video${percentPlayed}complete`;

                                }
                                digitalData.push({
                                    event: eventType,
                                    videoDetail: {
                                        videoID,
                                        videoName,
                                        videoLanguage,
                                        videoCaptionLanguage: instance.selectedTrack ? instance.selectedTrack.srclang : '',
                                        videoLength: instance.getDuration()
                                    }
                                });

                                markers = markers.filter((item) => item !== percentPlayed);
                            }
                        });

                        window.addEventListener('pauseVideo', () => {
                            media.pause();
                        });

                        const vidParent = $(this).closest('.mejs__inner');
                        // Reorder caption options alphabetically
                        const captions = vidParent.find('.mejs__captions-selector-list-item');
                        const sortedCaptions = captions.sort((captionA, captionB) => {
                            const labelA = $(captionA).children('.mejs__captions-selector-label').text().toLowerCase();
                            const labelB = $(captionB).children('.mejs__captions-selector-label').text().toLowerCase();
                            if (labelA !== 'none' && labelB !== 'none') {
                                if (labelA < labelB) {
                                    return -1;
                                }
                                if (labelA > labelB) {
                                    return 1;
                                }
                            }
                            return 0;
                        });
                        sortedCaptions.appendTo(captions.parent('.mejs__captions-selector-list'));
                        // Update Poster image Alt text
                        const posterAlt = $(this).attr('data-poster-alt');
                        const posterImg = vidParent.find('.mejs__poster-img:first');
                        posterImg.attr('alt', posterAlt);
                    }
                });
            }).get();
        };

        if (!document.querySelectorAll('.carousel video.ra__player').length > 0) {
            console.debug('Standard video initialization');
            initPlayers();
        }
        // Delay video initialization for tab/carousel clone's creation
        window.addEventListener('init-video-players', initPlayers);
    }

}

registerComponent(`.${componentName}`, Video);
